import { Tag, TagProps } from "@chakra-ui/react";
import { memo } from "react";

export default memo(function ({ color, ...tagProps }: TagProps) {
  return <Tag bg={"theme.dark.background"} borderColor={color} borderWidth={2} color={color} {...tagProps} />;
});
